import styled from '@emotion/styled';
import { Flex } from './Flex';
import Icon from './Icon';
import { theme } from '../../design-system';
import { shouldForwardProps } from '../../helpers';

const getPropsByVariant = (variant) => {
  const variants = {
    success: {
      borderBottom: '3px solid #00B092',
      color: '#00B092',
    },
    error: { borderBottom: '3px solid #E25822', color: '#E25822' },
  };

  return variant ? variants[variant] : {};
};

const StyledInput = ({ readOnly }) => {
  return {
    width: '100%',
    minHeight: '2rem',
    padding: '12px',
    color: theme.colors.neutralDark,
    backgroundColor: readOnly ? theme.colors.neutralLight : '#fafafa',
    '&::placeholder': { color: readOnly ? theme.colors.neutralDark : '#aabbc6' },
  };
};

const StyledWrapper = ({ readOnly, variant }) => {
  const propsByVariant = getPropsByVariant(variant);

  return {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: readOnly ? theme.colors.neutralLight : '#fafafa',
    border: '1px solid #d6e4ec',
    borderRadius: '4px',
    cursor: 'text',
    '&:focus-within': !readOnly && {
      borderBottom: '3px solid #7480FF',
      filter: 'drop-shadow(0px 0px 2px rgba(117, 131, 142, 0.04)) drop-shadow(0px 4px 8px rgba(52, 60, 68, 0.16))',
    },
    '& > input': { outline: 'none', border: 'none', color: propsByVariant.color },
    ...propsByVariant,
  };
};

const InputElement = styled('input')(StyledInput);
const Wrapper = styled('div')(StyledWrapper);
const Label = styled('label')`
  margin-bottom: 1rem;
`;

export const Input = ({ icon, variant, ...props }) => {
  const { label, name: inputName, readOnly, type, placeholder, value, onChange, autoFocus, onKeyUp, ...allOtherProps } = props;
  const { customPropsObj } = shouldForwardProps(allOtherProps);
  const propsByVariant = getPropsByVariant(variant);

  return (
    <Flex column {...customPropsObj}>
      {label && <Label htmlFor={inputName}>{label}</Label>}
      <Wrapper readOnly={readOnly} variant={variant}>
        {icon && <Icon icon={icon} marginLeft='1rem' color={propsByVariant.color} />}
        <InputElement
          name={inputName}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          onKeyUp={onKeyUp}
          autoFocus={autoFocus}
        />
      </Wrapper>
    </Flex>
  );
};
